import { useMutation, useQueryClient } from '@tanstack/vue-query';
import { queries } from '~/keys';

// Agent releases their own ACTIVE hold (ID-119). Errors are shown inline next to the hold row.
export const useReleaseExclusiveHold = () => {
  const authStore = useAuthStore();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (holdId: string) =>
      $fetch(`/api/exclusives/holds/${holdId}/release`, {
        method: 'POST',
        headers: { Authorization: `Bearer ${authStore.token}` },
      }),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: queries.exclusiveUnits._def }),
  });
};
